import { OMSAssignmentCandidate } from '@/api/apis/resources';
import { OMSShiftCell } from './OMSShiftCell';
import { displayPhoneNumber } from '@/utils/helpers';
import { AvatarWithName, MandatoryRoleAssignButton } from '../components';
import { OMSReservationCondition } from './OMSReservationCondition';
import { OMSShiftType } from '@/api/apis/resources/schedule/schedule.types';

export type OMSRowData = OMSAssignmentCandidate & {
  isSelected: boolean;
  isPrimary: boolean;
  isLast: boolean;
};

export const renderOMSTableCell = (onAssign: (oms: OMSRowData) => void) => (item: OMSRowData, columnKey: string) => {
  const {
    isPrimary,
    isSelected,
    isLast,
    employeeFullName,
    employeeProfilePhoto,
    phone,
    currentShiftEnd,
    currentSlotShiftType,
    nextOnCallStart,
    overlapCSOnCallShiftEnd,
    overlapCSOnCallShiftStart,
    overlapPhoneSupportShiftEnd,
    overlapPhoneSupportShiftStart,
  } = item;

  switch (columnKey) {
    case 'name':
      return <AvatarWithName name={employeeFullName!} photo={employeeProfilePhoto!} isPrimary={isPrimary} />;
    case 'phone':
      return <span>{phone ? displayPhoneNumber(phone) : '-'}</span>;
    case 'currentShift':
      return <OMSShiftCell date={currentShiftEnd} shiftType={currentSlotShiftType} />;
    case 'nextShift':
      return <OMSShiftCell date={nextOnCallStart} shiftType={OMSShiftType.OnCall} />;
    case 'reservationCondition':
      return (
        <OMSReservationCondition
          overlapCSOnCallShiftEnd={overlapCSOnCallShiftEnd}
          overlapCSOnCallShiftStart={overlapCSOnCallShiftStart}
          overlapPhoneSupportShiftEnd={overlapPhoneSupportShiftEnd}
          overlapPhoneSupportShiftStart={overlapPhoneSupportShiftStart}
        />
      );
    case 'action':
      return (
        <MandatoryRoleAssignButton
          isSelected={isSelected}
          isLast={isLast}
          name={employeeFullName!}
          roleName="Organ Management Specialist"
          onAssign={() => onAssign(item)}
        />
      );
    default:
      return null;
  }
};
